export default function ScoreBar({ label, value, accent = false }) {
  const pct = Math.max(0, Math.min(100, value));
  return (
    <div className="space-y-1.5" data-testid={`score-${label.toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="flex items-center justify-between text-xs">
        <span className="overline">{label}</span>
        <span className="font-medium tabular-nums">{Math.round(pct)}</span>
      </div>
      <div className="h-1.5 w-full bg-secondary rounded-full overflow-hidden">
        <div
          className={`h-full rounded-full transition-all duration-700 ${accent ? "bg-primary" : "bg-foreground/70"}`}
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
